import { FC } from 'react';

import IconFile from '@/assets/svg/icon-img.svg?react';

import { Button } from '@/components/ui/button';

interface FileSelectionHeaderProps {
  onLeftSelect: () => void;
  onRightSelect: () => void;
  leftFilename?: string;
  rightFilename?: string;
}

const FileSelectionHeaderMobile: FC<FileSelectionHeaderProps> = ({
  onLeftSelect,
  onRightSelect,
  leftFilename,
  rightFilename,
}) => (
  <>
    <div className="order-1 mb-1 flex justify-between gap-3.5">
      <Button
        onClick={onLeftSelect}
        variant="outline"
        className="h-[40px] text-lg"
      >
        Обрати файл
      </Button>
      <div className="text flex items-center gap-4">
        <IconFile className="h-4 min-w-4 fill-dark-red" />
        {leftFilename || 'Оберіть файл'}
      </div>
    </div>
    <div className="order-3 mb-2 mt-2 flex justify-between gap-3.5">
      <Button
        onClick={onRightSelect}
        variant="outline"
        className="h-[40px] text-lg"
      >
        Обрати файл
      </Button>
      <div className="text flex items-center gap-4">
        <IconFile className="h-4 min-w-4 fill-dark-red" />
        {rightFilename || 'Оберіть файл'}
      </div>
    </div>
  </>
);

export default FileSelectionHeaderMobile;
